import React, { useState } from "react";
import "./Dropdown.css";
import { useNavigate } from "react-router-dom";

const Dropdown = props => {
    const { data, setIsMenu } = props;
    const navigate = useNavigate();
    const { title, children } = data;
    const [isShow, setShow] = useState("");

    const handleClick = item => {
        if (isShow === item) {
            setShow("");
        } else {
            setShow(item);
        }
    };

    const handleAbout = () => {
        setIsMenu(false);
        navigate("/learn");
    };

    const handleResource = item => {
        setIsMenu(false);
        if (item === "All Downloads") {
            navigate("/resources");
        }
        if (item === "Case Studies") {
            navigate("/case-study");
        }
        if (item === "Warranties / Terms & Conditions") {
            navigate("/warranty-docs");
        }
    };

    const handleProduct = item => {
        setIsMenu(false);
        if (item === "all") {
            navigate("/products");
        }
        navigate(`/products/category/${item.attributes.name}`);
    };

    return (
        <React.Fragment>
            <button className="dropbtn" onClick={() => handleClick(title)}>
                {title}
            </button>
            {title === "About DSSL" && (
                <div className="dropdown-content mobile-dropdown-content">
                    {children.map((item, index) => {
                        if (item === "Our Story") {
                            return (
                                <a key={index} onClick={handleAbout}>
                                    {item}
                                </a>
                            );
                        }
                        if (item === "Contact Us") {
                            return (
                                <a
                                    key={index}
                                    href="#contact-us"
                                    onClick={handleAbout}
                                >
                                    {item}
                                </a>
                            );
                        }
                    })}
                </div>
            )}
            {title === "Resources" && (
                <div className="dropdown-content mobile-dropdown-content">
                    {children.map((item, index) => {
                        if (item === "All Downloads") {
                            return (
                                <a
                                    key={index}
                                    onClick={() => handleResource(item)}
                                >
                                    {item}
                                </a>
                            );
                        }
                        if (item === "Case Studies") {
                            return (
                                <a
                                    key={index}
                                    onClick={() => handleResource(item)}
                                >
                                    {item}
                                </a>
                            );
                        }

                        if (item === "Warranties / Terms & Conditions") {
                            return (
                                <a
                                    key={index}
                                    onClick={() => handleResource(item)}
                                >
                                    {item}
                                </a>
                            );
                        }
                    })}
                </div>
            )}
            {title === "Products" && (
                <div className="dropdown-content mobile-dropdown-content">
                    {children.map((item, index) => {
                        return (
                            <a key={index} onClick={() => handleProduct(item)}>
                                {item.attributes.name}
                            </a>
                        );
                    })}
                    <a onClick={() => handleProduct("all")}>All Products</a>
                </div>
            )}
        </React.Fragment>
    );
};

export default Dropdown;
